import CampoMultiSeletor from '../Formulario/CampoMultiSeletor';
import axios from 'axios';
import { useQuery } from 'react-query';

type FiltroAtendenteProps = {
    value: string[];
    onChange: (value: string[]) => void;
};

export const FiltroAtendente = ({ value, onChange }: FiltroAtendenteProps) => {
    const q = useQuery(['usuario/box'], async () => {
        const res = await axios.get<{ result: any[] }>('/api/usuario/box', {
            withCredentials: true,
        });
        return res.data;
    });

    const options =
        q.data?.result?.map(item => ({
            id: item.id.toString(),
            label: item.nome,
        })) ?? [];

    return (
        <CampoMultiSeletor
            label="Atendente responsável"
            placeholder="(Qualquer)"
            options={options}
            value={value}
            onChange={onChange}
        />
    );
};
